// 公告与侧边栏共用的访问线路，避免入口地址和推荐标记不一致。
export const ACCESS_ROUTES = [
  { url: 'https://zd878.club', descriptionKey: 'international', recommended: true },
  { url: 'https://zd87.com', descriptionKey: 'hongKong' },
  { url: 'https://aimonkey.plus', descriptionKey: 'hongKong' },
  { url: 'https://zd878.one', descriptionKey: 'us' },
];
